/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListSampleRequestsQueryResponse,
  ListSampleRequestsQueryParams,
} from '../types/ListSampleRequests'

function getListSampleRequestsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/samples/sample-requests/` as const,
  }
  return res
}

/**
 * @description ViewSet for sample request operations.
 * Architecture:
 * - READ operations (list, retrieve): Pure DRF pattern
 * - WRITE operations (create, update, cancel, review): Use case pattern
 * - Async export handled by ExportSampleRequestsV2View in downloads app.
 * @summary List sample requests
 * {@link /api/v1/samples/sample-requests/}
 */
export async function listSampleRequests(
  params?: ListSampleRequestsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListSampleRequestsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListSampleRequestsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
